<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
    description?: string
    actionText?: string
    tone?: 'neutral' | 'brand' | 'warn'
  }>(),
  { description: '', actionText: '', tone: 'neutral' },
)

const emit = defineEmits<{ (e: 'action'): void }>()
</script>

<template>
  <div class="yc-empty" :class="`yc-empty--${tone}`">
    <svg class="yc-empty__art" viewBox="0 0 160 100" fill="none" aria-hidden="true">
      <rect x="30" y="22" width="100" height="62" rx="6" stroke="currentColor" stroke-width="1.5" />
      <path d="M30 40 H130" stroke="currentColor" stroke-width="1.5" />
      <circle cx="40" cy="31" r="2.5" fill="currentColor" />
      <circle cx="49" cy="31" r="2.5" fill="currentColor" />
      <path d="M46 62 H114" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      <path d="M46 72 H92" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity=".5" />
    </svg>
    <h3 class="yc-empty__title">{{ title }}</h3>
    <p v-if="description" class="yc-empty__desc">{{ description }}</p>
    <el-button v-if="actionText" type="primary" @click="emit('action')">{{ actionText }}</el-button>
    <slot />
  </div>
</template>

<style scoped lang="scss">
.yc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--yc-space-8) var(--yc-space-6);
  text-align: center;
  color: var(--yc-text-muted);

  &--brand {
    color: var(--yc-brand);
  }

  &--warn {
    color: var(--yc-warn);
  }

  &__art {
    width: 160px;
    max-width: 60%;
    opacity: 0.5;
  }

  &__title {
    margin: var(--yc-space-4) 0 var(--yc-space-2);
    color: var(--yc-text);
    font-size: var(--yc-font-lg);
    font-weight: 600;
  }

  &__desc {
    max-width: 420px;
    margin: 0 0 var(--yc-space-4);
    color: var(--yc-text-secondary);
    font-size: var(--yc-font-sm);
    line-height: 1.7;
  }
}
</style>